var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"20vw","height":"100%"}},[_c('div',{staticClass:"xj"},[_c('div',{staticClass:"i_top"},[_vm._v(_vm._s(_vm.id)),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.time))])]),_vm._l((_vm.infoList),function(item,index){return _c('div',{key:index,staticClass:"i_content i_content_white"},[_c('el-row',[_c('el-col',{staticClass:"i_content_name",attrs:{"span":14}},[_vm._v(_vm._s(item.alias))]),_c('el-col',{staticClass:"i_content_value word_green",style:({
                    color:
                      item.colour == 'green'
                        ? '#4DCB73'
                        : item.colour == 'red'
                        ? 'rgba(224, 32, 32, 1)'
                        : item.colour == 'yellow'
                        ? 'yellow'
                        : '',
                  }),attrs:{"span":6}},[_vm._v(_vm._s(item.value)+" "+_vm._s(item.unit))])],1)],1)})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }